import React from "react"
import { Formik, Form } from "formik"
import { TextField, FormControl, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"

const EMAIL_REGEX = /^[a-z0-9][_\-.+!#$%&'*/=?^`{|]{0,1}([a-z0-9][_\-.+!#$%&'*/=?^`{|]{0,1})*[a-z0-9]@[a-z0-9][-.]{0,1}([a-z][-.]{0,1})*[a-z0-9]\.[a-z0-9]{1,}([.-]{0,1}[a-z]){0,}[a-z0-9]{0,}$/

const PHONE_REGEX = /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/

const validateDeliveryNoteContact = (values) => {
  const errors = {}
  if (values.internalMail && !values.internalMail.match(EMAIL_REGEX)) {
    errors.internalMail = "Adresse email invalide"
  }
  if (values.externalMail && !values.externalMail.match(EMAIL_REGEX)) {
    errors.externalMail = "Adresse email invalide"
  }
  if (values.contactEmail && !values.contactEmail.match(EMAIL_REGEX)) {
    errors.contactEmail = "Adresse email invalide"
  }
  if (values.contactPhone && !values.contactPhone.match(PHONE_REGEX)) {
    errors.contactPhone = "Numéro de téléphone invalide"
  }
  return errors
}

const useStyles = makeStyles(() => ({
  BLInfoContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flexWrap: "wrap"
  },
  field: {
    width: "100%",
    marginBottom: 10
  },
  contactBoxTitle: {
    fontSize: "11px",
    fontWeight: 500,
    color: "#757575",
    textTransform: "uppercase",
    letterSpacing: "0.08em"
  }
}))

export const distributionCenterDeliveryNoteConfigFormId = "distributionCenterDeliveryNoteConfigFormId"

const DistributionCenterDeliveryNoteConfigForm = ({ distributionCenter = {}, handleSubmit }) => {

  const classes = useStyles()

  return (
    <Formik
      onSubmit={handleSubmit}
      validate={validateDeliveryNoteContact}
      initialValues={{
        counterMark: distributionCenter.counterMark,
        supplierCode: distributionCenter.supplierCode,
        internalMail: distributionCenter.internalMail,
        externalMail: distributionCenter.externalMail,
        contactName: distributionCenter.contactName || "",
        contactEmail: distributionCenter.contactEmail || "",
        contactPhone: distributionCenter.contactPhone || ""
      }}
    >
      {({ values, handleChange, handleBlur, errors, touched }) => (
        <Form
          id={distributionCenterDeliveryNoteConfigFormId}>
          <div className={classes.BLInfoContainer}>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="counterMark"
                  label="Contremarque"
                  value={values.counterMark}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </FormControl>
            </div>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="supplierCode"
                  label="Code fournisseur"
                  value={values.supplierCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </FormControl>
            </div>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="internalMail"
                  label="Mail interne"
                  value={values.internalMail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.internalMail && Boolean(errors.internalMail)}
                  helperText={touched.internalMail && errors.internalMail}
                />
              </FormControl>
            </div>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="externalMail"
                  label="Mail externe"
                  value={values.externalMail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.externalMail && Boolean(errors.externalMail)}
                  helperText={touched.externalMail && errors.externalMail}
                />
              </FormControl>
            </div>
            <div>
              <Typography className={classes.contactBoxTitle}>Contact BL</Typography>
            </div>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="contactName"
                  label="Nom du contact"
                  value={values.contactName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </FormControl>
            </div>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="contactEmail"
                  label="Email du contact"
                  value={values.contactEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.contactEmail && Boolean(errors.contactEmail)}
                  helperText={touched.contactEmail && errors.contactEmail}
                />
              </FormControl>
            </div>
            <div>
              <FormControl variant="standard" className={classes.field}>
                <TextField
                  variant="standard"
                  name="contactPhone"
                  label="Téléphone du contact"
                  value={values.contactPhone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.contactPhone && Boolean(errors.contactPhone)}
                  helperText={touched.contactPhone && errors.contactPhone}
                />
              </FormControl>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default DistributionCenterDeliveryNoteConfigForm